<script lang="ts">
  export let extraClassNames: string = "";
</script>

<div class="{extraClassNames} flex h-full w-full flex-col">
  <slot />
</div>
